import { createApi } from '@reduxjs/toolkit/query/react';
import {
    SubmittingFormContactBrandsRequestIF,
    SubmittingFormContactBrandsResponseIF,
} from '@/api/partnersApi/types';
import { fetchRestApiQuery } from '@/helpers/api';

export const partnersApi = createApi({
    reducerPath: 'partnersApi',
    baseQuery: fetchRestApiQuery('/Partners'),
    tagTypes: ['Partners'],
    endpoints: (builder) => ({
        submittingFormContactBrands: builder.mutation<
            SubmittingFormContactBrandsResponseIF,
            SubmittingFormContactBrandsRequestIF
        >({
            query: (data) => ({
                url: '/submitting_a_form_to_contact_brands',
                method: 'POST',
                body: data,
            }),
        }),
    }),
});

export const { useSubmittingFormContactBrandsMutation } = partnersApi;
